// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2fgoN","left":"StickyBox_left__t1AhV","right":"StickyBox_right__1XG4X"};